<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="goToContactUs()">
        <ion-icon name="information-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div class="ion-text-center" hidden>
          <p>Version {{appVersion}} Build {{buildVersion}}</p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div>
    <form [formGroup]="loginForm" (ngSubmit)="verifyLogin()">
      <app-phone-input
        [control]="loginForm.controls['phone']"
        (phoneChange)="phoneNumber = $event"
      ></app-phone-input>
    </form>
  </div>
</ion-content>
<ion-footer class="auth-footer">
  <ion-toolbar color="primary">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" [disabled]="!loginForm.valid" (click)="verifyLogin()" class="auth-button primary">Send me a code</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>